module.exports = __webpack_public_path__ + "img/1559554393.847928ab.jpg";